// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__2PoaC","author":"Table_author___qurH","authorImage":"Table_authorImage__3i03C","unreadRow":"Table_unreadRow__2PhSC"};